(function ($) {
  "use strict";

  // javascript code here. i.e.: $(document).ready( function(){} );
})(jQuery);
